import { makeAutoObservable } from 'mobx';
import { EmailSignUpDto, UserInfoDto, UserProfileDto } from 'services/data-contracts';
import { UserFilterType, AdminUserFilterType } from 'types/CommonTypes';
import ServiceHelper from './ServiceHelper';
import { PaginationInfo, getPaginationHeader } from 'libs/helper/paginationUtil';
export interface isValid {
  isValid: boolean;
}

class UserFilterStore {
  users: UserInfoDto[] = [];
  adminUsers: UserInfoDto[] = [];

  filteredUsers: UserInfoDto[] = [];
  filteredAdminUsers: UserInfoDto[] = [];

  adminUserConditions: AdminUserFilterType;

  page: number = 0;
  size: number = 20;

  paginationInfo: PaginationInfo | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  // 일반회원 목록 조회
  getUsers(filter: UserFilterType) {
    ServiceHelper.adminUserService
      ?.getUsers({
        searchKeyword: filter.searchKeyword?.trim() ?? '',
        page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? this.size,
      })
      .then((res) => {
        this.users = [...res.data];
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }

  // 관리자 목록 조회
  getAdminUsers(filter: AdminUserFilterType) {
    this.adminUserConditions = { ...this.adminUserConditions, ...filter };

    ServiceHelper.adminMemberService
      ?.getAdminMembers({
        searchKeyword: filter.searchKeyword?.trim() ?? '',
        page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? this.size,
      })
      .then((res) => {
        // this.adminUsers = res.data;
        this.adminUsers = res.data.map((user) => ({
          ...user,
          isAdmin: true,
        }));
        this.filteredAdminUsers = res.data.filter((user) => {
          if (this.adminUserConditions.type === 'all') {
            return true;
          } else if (this.adminUserConditions.type === 'active') {
            return user.isWithdrawn === false;
          } else if (this.adminUserConditions.type === 'withdrawn') {
            return user.isWithdrawn === true;
          }

          return true;
        });
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }

  // 관리자 계정 필터 설정 (활성/비활성)
  setAdminUserFilter(filter: AdminUserFilterType) {
    this.adminUserConditions = { ...this.adminUserConditions, ...filter };

    this.filteredAdminUsers = this.adminUsers.filter((user) => {
      if (filter.type === 'all') {
        return true;
      }

      if (filter.type === 'active') {
        return user.isWithdrawn === false;
      }

      if (filter.type === 'withdrawn') {
        return user.isWithdrawn === true;
      }

      return false;
    });
  }

  unmount() {
    this.users = [];
    this.filteredUsers = [];
    this.adminUsers = [];
    this.filteredAdminUsers = [];
    this.paginationInfo = null;
  }
}

export default UserFilterStore;
